<script>
	const _ = require('underscore');
	const Q = require('q');
	const model = require('model/model');
	const Vue = require('vue');
	const scrollManager = require('ui/core/scrollManager');
	const { v4: uuidv4 } = require('uuid');
	const utilities = require('utilities');
	const aadVocabUtilities = require('utilities/aadVocabUtilities');
	const getGraphicOrganizer = aadVocabUtilities.getGraphicOrganizer;
	const createNode = aadVocabUtilities.createNode;
	const updateNode = aadVocabUtilities.updateNode;
	const deleteNode = aadVocabUtilities.deleteNode;

	let rootId = uuidv4();
	let leafParent = uuidv4();
	const demoData = {
		nodes: [
			{
				id: rootId,
				root: true,
				word: 'Fossil',
				text: 'the remains or trace of an animal or plant from a long time ago; found in earth or rock.'
			},
			{
				id: leafParent,
				word: 'Dinosaur',
				linkText: 'Fossils are old bones we can find from dinosaurs.',
				parentId: rootId
			},
			{
				id: uuidv4(),
				word: 'Rot',
				linkText: 'A fossil is the part of the dinosaur that did not rot.',
				parentId: rootId
			},
			{
				id: uuidv4(),
				word: 'Fierce',
				linkText: 'A T-rex is an example of a fierce dinosaur.',
				parentId: leafParent
			}
		]
	};

	module.exports = {
		props: ['aid', 'product', 'demo', 'organizerData', 'numberOfSubmittedArticles', 'assignmentOptions'],
		modelData: ['graphicOrganizer', 'graphicOrganizerInstructionsDismiss', 'userContext', 'printing'],
		components: {
			'load-mask': require('components/load-mask.vue').default,
			'graphic-organizer': require('components/graphic-organizer.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'validated-input': require('components/validated-input.vue').default,
			'article-overlay': require('components/article-overlay.vue').default,
			'meaning-map-icon': require('components/svg/meaning-map-icon.vue').default
		},
		data() {
			return {
				loading: true,
				addText: null,
				editParentId: null,
				editFocusWordDef: '',
				editLinkText: '',
				editWord: '',
				chosenArticle: null,
				editNode: null,
				allowDelete: false,
				createdNodeId: null,
				initialRound: false
			};
		},
		computed: {
			activity() {
				let product = this.product;
				let value = null;
				if (product && product.meaning_mapper) {
					value = product.meaning_mapper;
				}
				return value;
			},
			articleBank() {
				let product = this.product;
				let activity = this.activity;
				let assignmentOptions = this.assignmentOptions || {};
				let bank = [];

				if (activity) {
					let rawBank = [];

					if (activity.student_word_bank) {
						rawBank = rawBank.concat(activity.student_word_bank);
					}
					if (activity.student_word_bank_challenge && assignmentOptions.challenge) {
						rawBank = rawBank.concat(activity.student_word_bank_challenge);
					}
					if (activity.student_word_bank_support && assignmentOptions.support) {
						rawBank = rawBank.concat(activity.student_word_bank_support);
					}

					let articleMap = rawBank.reduce((acc, word) => {
						if (acc[word.text]) {
							acc[word.text].push(word.word);
						} else {
							acc[word.text] = [word.word];
						}
						if (acc[word.text] && word.word_variants) {
							acc[word.text] = acc[word.text].concat(...word.word_variants);
						}
						return acc;
					}, {});
					bank = Object.keys(articleMap).map(pid => {
						let article = product.allArticles[pid];
						return _.assign(
							{
								pid: pid,
								words: articleMap[pid]
							},
							article
						);
					});
				}
				return bank;
			},
			focusWord() {
				let activity = this.activity;
				let word = null;
				if (activity && activity.focus_word && activity.focus_word.word) {
					word = activity.focus_word.word;
				}

				return word;
			},
			organizer() {
				let organizerData = this.organizerData;
				let graphicOrganizer = this.graphicOrganizer;
				let product = this.product;
				let org = null;

				if (product && product.meaning_mapper) {
					this.addText = null;

					if (organizerData) {
						org = _.assign({}, organizerData);
					} else if (graphicOrganizer && graphicOrganizer.nodes) {
						org = _.assign({}, graphicOrganizer);
						if (graphicOrganizer.nodes.length < 2) {
							this.addText = 'To get started, click the + to add your first word!';
						} else if (graphicOrganizer.nodes.length < 3) {
							this.addText = 'Click the + to add a word!';
						}
					}
				}
				return org;
			},
			rootNode() {
				let graphicOrganizer = this.graphicOrganizer;
				let node = null;
				if (graphicOrganizer && graphicOrganizer.nodes && graphicOrganizer.nodes.length) {
					graphicOrganizer.nodes.some(n => {
						if (n.root) {
							node = n;
							return true;
						}
						return false;
					});
				}
				return node;
			},
			parentNode() {
				let editParentId = this.editParentId;
				let graphicOrganizer = this.graphicOrganizer;
				let node = null;

				if (editParentId && graphicOrganizer && graphicOrganizer.nodes && graphicOrganizer.nodes.length) {
					graphicOrganizer.nodes.some(n => {
						if (n.id === editParentId) {
							node = n;
							return true;
						}
						return false;
					});
				}
				return node;
			},
			overlayArticles() {
				let product = this.product;
				let chosenArticle = this.chosenArticle;
				let overlayArticleList = chosenArticle ? [chosenArticle] : null;
				let articles = null;

				if (product && overlayArticleList && overlayArticleList.length) {
					articles = overlayArticleList;
				}

				return articles;
			},
			rootText() {
				let rootNode = this.rootNode;
				let text = null;
				if (rootNode && rootNode.text) {
					text = utilities.linebreakStr(rootNode.text);
				}
				return text;
			},
			isStudent() {
				let userContext = this.userContext;
				let student = false;
				if (userContext && userContext.classCode) {
					student = true;
				}
				return student;
			},
			showReadArticlesButton() {
				let initialRound = this.initialRound;
				let graphicOrganizer = this.graphicOrganizer;
				let isStudent = this.isStudent;
				let show = false;

				if (isStudent && initialRound && graphicOrganizer && graphicOrganizer.nodes.length >= 2) {
					show = true;
				}
				return show;
			}
		},
		methods: {
			onCreateNodeClick(parentNode) {
				if (this.organizerData) {
					return;
				}

				this.onEndEdit();
				this.editParentId = parentNode.id;

				if (parentNode.id) {
					utilities.openModal('#meaning-mapper-add-word');
				}
			},
			onInitSubmit() {
				let aid = this.aid;
				let editNode = this.editNode;
				let word = this.focusWord;
				let linkText = undefined;
				let text = this.editFocusWordDef;
				let prms = Q();

				this.onEndEdit();

				this.loading = true;
				if (editNode) {
					prms = updateNode(aid, editNode.id, editNode.parentId, word, text, linkText);
				}

				return prms.then(() => (this.loading = false));
			},
			onCreateNodeSubmit() {
				let aid = this.aid;
				let parentId = this.editParentId;
				let editNode = this.editNode;
				let word = this.editWord;
				let linkText = this.editLinkText;
				let text = undefined;
				let prms = Q();

				this.onEndEdit();

				this.loading = true;
				if (editNode) {
					prms = updateNode(aid, editNode.id, editNode.parentId, word, text, linkText);
				} else if (parentId) {
					prms = createNode(aid, parentId, word, text, linkText);
				}

				prms
					.then(node => {
						let graphicOrganizer = this.graphicOrganizer;
						this.loading = false;
						if (!editNode) {
							this.createdNodeId = node.id;
						}
						if (!this.initialRound && graphicOrganizer.nodes.length > 2) {
							utilities.openModal('#meaning-mapper-success');
						}
					})
					.done();
			},
			onNodeClick(node) {
				if (!node.parentId) {
					utilities.openModal('#meaning-mapper-init');

					this.editNode = node;
					this.editWord = node.word;
					this.editFocusWordDef = node.text;

					this.refreshRootForm();
				} else if (node && this.$refs.editForm) {
					this.onEndEdit();

					utilities.openModal('#meaning-mapper-add-word');

					this.editNode = node;
					this.editLinkText = node.linkText;
					this.editWord = node.word;
					this.allowDelete = this.isNodeLeaf(node.id);

					this.refreshForm();
				}
			},
			onEndEdit() {
				utilities.closeModals();
				this.editLinkText = '';
				this.editParentId = null;
				this.editFocusWordDef = '';
				this.editWord = '';
				this.editNode = null;
				this.allowDelete = false;
			},
			refreshForm() {
				if (this.$refs && this.$refs.editForm) {
					Vue.nextTick(() => this.$refs.editForm.change());
				}
			},
			refreshRootForm() {
				if (this.$refs && this.$refs.rootForm) {
					Vue.nextTick(() => this.$refs.rootForm.change());
				}
			},
			setOverlayArticles(article) {
				this.chosenArticle = article;
				if (this.$refs.organizerOverlayContainer) {
					scrollManager(this.$refs.organizerOverlayContainer, {
						priority: 2,
						duration: 500
					});
				}
			},
			closeOverlay() {
				const articleBank = this.articleBank || [];
				const chosenIndex = articleBank.indexOf(this.chosenArticle);

				if (chosenIndex !== -1) {
					this.$refs.articleBankLink[chosenIndex].focus();
				}

				this.chosenArticle = null;
			},
			isNodeLeaf(id) {
				let organizer = this.organizer;
				let nodes = organizer && organizer.nodes;
				let isLeaf = false;
				if (nodes && nodes.length) {
					isLeaf = !nodes.some(n => n.parentId === id);
				}
				return isLeaf;
			},
			onDeleteNode() {
				let editNode = this.editNode;
				let id = editNode && editNode.id;
				let aid = this.aid;
				let isLeaf = this.isNodeLeaf(id);

				this.onEndEdit();

				if (id && isLeaf) {
					this.loading = true;
					deleteNode(aid, id)
						.then(() => (this.loading = false))
						.done();
				}
			},
			onHelpClick() {
				utilities.openModal('#meaning-mapper-instructions');
			},
			dismissInstructions() {
				utilities.closeModals();
				let dismiss = model.get('graphicOrganizerInstructionsDismiss') || {};
				dismiss.meaningMapper = true;
				model.set('graphicOrganizerInstructionsDismiss', dismiss);
			},
			startReadingClick() {
				if (this.showReadArticlesButton) {
					model.set('articleDashboardTab', 'articles');
				}
			},
			closeModals() {
				utilities.closeModals();
			},
			checkSubmittedArticleModals() {
				if (this.numberOfSubmittedArticles === 1) {
					utilities.openModal('#meaning-mapper-read-article');
				}
			}
		},
		watch: {
			activity: {
				handler(a) {
					if (a && !this.demo && !this.organizerData && this.aid) {
						this.loading = true;
						getGraphicOrganizer(this.aid)
							.then(organizer => {
								this.loading = false;
								if (organizer && organizer.nodes.length < 2) {
									this.initialRound = true;
									if (organizer.nodes.length === 0) {
										this.editFocusWordDef = a.focus_word.definition;

										let aid = this.aid;
										let parentId = undefined;
										let word = this.focusWord;
										let linkText = undefined;
										let text = this.editFocusWordDef;

										this.loading = true;
										createNode(aid, parentId, word, text, linkText).then(() => (this.loading = false));
									}
								}
							})
							.done();
					}
				},
				immediate: true
			},
			numberOfSubmittedArticles(n) {
				this.checkSubmittedArticleModals();
			}
		},
		mounted() {
			let dismiss = model.get('graphicOrganizerInstructionsDismiss') || {};
			model.remove('graphicOrganizer');

			if (this.demo) {
				this.$emit('update:organizerData', demoData);
				this.loading = false;
			}

			this.loading = false;
			Vue.nextTick(() => {
				if (!dismiss.meaningMapper && this.isStudent) {
					utilities.openModal('#meaning-mapper-instructions');
				}
				this.checkSubmittedArticleModals();
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.meaning-mapper {
		position: relative;

		#meaning-mapper-add-word {
			.modal-window-wrap {
				max-width: $max-width-inner;
			}
		}

		#meaning-mapper-init.modal.graphic-organizer-modal {
			.modal-content {
				.meaning-mapper-root-node {
					width: 240px;
					height: 240px;
					border-radius: 120px;
					padding: 1rem;
					margin: 1rem auto;

					input.validated-input.word {
						background-color: transparent;
						height: auto;
						margin: 0 0 0.25rem 0;

						&:not(.date-input) + label {
							// margin-top: calc(-2rem - 0px);
						}
					}
				}
			}
		}

		.loading-container .loading-plaque {
			border: 2px solid $c-blue;
		}

		.meaning-mapper-canvas {
			.link-node {
				stroke: $c-slate-dark;
				stroke-width: 1;
				rx: 5;
				ry: 5;
			}

			.link-node-text > tspan {
				font-size: 14px;
				font-weight: normal;
			}
		}

		.start-reading-button {
			margin: 1rem 0;
		}
	}

	.modal.graphic-organizer-modal {
		.modal-content {
			.meaning-mapper-root-node {
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 1rem 0;
				border: 2px solid $c-slate;
				border-radius: 80px;
				width: 160px;
				height: 160px;
				margin: 1rem 0;

				.word-part {
					font-size: 1rem;
					font-weight: bold;
				}

				textarea {
					font-size: 14px;
				}
			}

			.validated-textarea.focus-word-definition {
				textarea {
					min-height: 75px;
				}
			}

			form.validated-form.meaning-mapper-edit-form {
				.input-wrapper.word-entry {
					// input[type=text].validated-input {
					border: 2px solid $c-blue;
					padding: 0rem 1rem;
					border-radius: 3rem;
					margin: 0;

					&.parent-word {
						display: flex;
						align-items: center;
						justify-content: center;
						flex-basis: 215px;
						padding: 1rem;
						min-height: 80px;
						font-weight: bold;
					}

					input[type='text'].validated-input {
						margin-top: 1rem;
						border-bottom-color: transparent;

						&:not(.date-input) + label {
							margin-top: calc(-2rem - 0px);
						}
					}

					// }
				}

				.node-container-form {
					display: flex;
					align-items: center;
					margin-bottom: 2rem;
				}

				.focus-word-definition {
					font-size: 14px;
				}

				.connection-entry {
					.validated-textarea {
						textarea {
							min-height: 80px;
							border-radius: 5px;
							border-color: $c-slate;
						}

						.placeholder {
							font-size: 1rem;
							margin: 1.5rem auto auto auto;
							left: 0;
							right: 0;
							top: 0;
							bottom: 0;
							padding: 0;
						}
					}

					input[type='text'].validated-input {
						border-radius: 5px;
						border-color: $c-grey;
					}
				}
			}
		}
	}

	.meaning-mapper-print {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.meaning-mapper-row {
			display: flex;
		}

		.meaning-mapper-blank,
		.meaning-mapper-center,
		.meaning-mapper-bank {
			border: 1px solid #000000;
		}

		.meaning-mapper-branch {
			flex-basis: 15rem;
			display: flex;
			position: relative;
			align-items: center;

			.line {
				flex-basis: 1rem;
				border-bottom: 1px dashed #000;
			}

			&.mm-secondary {
				flex-direction: column;
				flex-basis: auto;
				transform: translateY(-4.5rem);

				&.mm-top {
					transform: none;
				}

				.line {
					border-left: 1px dashed #000;
				}
			}

			&.spacer {
				flex-basis: 17.5rem;

				&.mm-bottom {
					flex-basis: 28.5rem;
				}
			}
		}

		.meaning-mapper-blank {
			width: 6.5rem;
			height: 2.5rem;
			border-radius: 1.25rem;
			background-color: #fff;
			z-index: 1;

			&.word {
				border-width: 2px;
			}

			&.connection {
				height: 4.5rem;
				border-radius: 2.25rem;
			}
		}

		.meaning-mapper-center {
			width: 11.5rem;
			height: 11.5rem;
			border-radius: 5.75rem;
			padding: 0.5rem;
			background-color: #fff;
			z-index: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
			text-align: center;
		}

		.meaning-mapper-word {
			font-weight: 700;
			margin-bottom: 0.5rem;
		}

		.meaning-mapper-definition {
			font-size: 0.7rem;
			line-height: 1;
			overflow-y: hidden;
			padding-bottom: 2px;
		}

		.word-bank-print {
			margin-bottom: 2rem;
			padding: 1rem;
			border: 1px solid #000000;
		}

		.word-bank-print-list {
			display: flex;
			flex-wrap: wrap;
			padding: 0;
			text-align: center;

			li {
				list-style: none;
				flex-basis: 20%;
			}
		}
	}
</style>
<template>
	<div class="meaning-mapper graphic-organizer-activity">
		<load-mask v-if="loading"></load-mask>
		<div
			ref="organizerOverlayContainer"
			class="organizer-overlay-container">
			<div
				v-if="showReadArticlesButton"
				class="start-reading-button-container text-centered">
				<button
					@click="startReadingClick"
					class="button start-reading-button">
					&larr; Start Reading
				</button>
			</div>
			<graphic-organizer
				class="meaning-mapper-canvas"
				:organizer="organizer"
				:add-text="addText"
				:leaf-add="true"
				:zoom-to="createdNodeId"
				:on-add-click="onCreateNodeClick"
				:on-node-click="!demo && !organizerData && onNodeClick"
				:on-help-click="onHelpClick">
			</graphic-organizer>
			<article-overlay
				v-if="overlayArticles && overlayArticles.length"
				:articles="overlayArticles"
				:highlight-words="chosenArticle && chosenArticle.words"
				:on-close-click="closeOverlay"></article-overlay>
		</div>
		<modal
			id="meaning-mapper-instructions"
			class="graphic-organizer-modal"
			:closeable="false">
			<div
				slot="content"
				class="instructions">
				<div class="instructions-header">
					<meaning-map-icon></meaning-map-icon>
					<h3>Become a Meaning Mapper!</h3>
				</div>
				<p>Creating maps of words helps you discover all the ways words connect, making learning words easy and fun!</p>
				<ol>
					<li>You will explore and learn the meaning of the focus word.</li>
					<li>
						After you read your article each day, choose a word from the article that connects to a word already on your map and fill in the connection
						bubble. Try to connect not just to the focus word but to new words you have added over the week!
					</li>
				</ol>
				<p>Have fun making as many connections as you can!</p>
				<button
					class="button -centered"
					@click="dismissInstructions">
					OK
				</button>
			</div>
		</modal>
		<modal
			id="meaning-mapper-read-article"
			class="graphic-organizer-modal"
			:closeable="false">
			<div
				slot="content"
				class="instructions">
				<p>
					Now that you have read an article, add at least one word that connects to the words on your map. Scroll down to click back to the article for
					help.
				</p>
				<button
					class="button -centered"
					@click="closeModals">
					OK
				</button>
			</div>
		</modal>
		<modal
			id="meaning-mapper-success"
			class="graphic-organizer-modal"
			:closeable="false">
			<div
				slot="content"
				class="instructions">
				<p class="text-centered">Way to grow your map of words and connections!</p>
				<div class="text-centered">
					<a
						href="/student"
						class="button">
						OK
					</a>
				</div>
			</div>
		</modal>
		<div
			v-if="articleBank && articleBank.length"
			class="word-bank">
			<div class="word-bank-title word-bank-cell">Find More Connecting Words!</div>
			<div class="word-bank-list">
				<a
					v-for="article in articleBank"
					:key="article.title"
					href="javascript:void(0)"
					aria-haspopup="dialog"
					@click="setOverlayArticles(article)"
					ref="articleBankLink"
					class="word-bank-word word-bank-cell">
					{{ article.title }}
				</a>
			</div>
		</div>
		<div
			v-if="printing"
			class="meaning-mapper-print">
			<div>
				<h1 class="margin-none">Meaning Mapper Graphic Organizer</h1>
				<p class="margin-top-xs margin-bottom-none">{{ product.title }}</p>
			</div>
			<div>
				<div class="meaning-mapper-row">
					<div class="meaning-mapper-branch spacer"></div>
					<div class="meaning-mapper-branch mm-secondary mm-top">
						<div class="meaning-mapper-blank connection"></div>
						<div class="line"></div>
						<div class="meaning-mapper-blank word"></div>
						<div class="line"></div>
					</div>
					<div class="meaning-mapper-branch spacer"></div>
				</div>
				<div class="meaning-mapper-row">
					<div class="meaning-mapper-branch mm-left">
						<div class="meaning-mapper-blank word"></div>
						<div class="line"></div>
						<div class="meaning-mapper-blank connection"></div>
						<div class="line"></div>
					</div>
					<div class="meaning-mapper-center">
						<div class="meaning-mapper-word">{{ focusWord }}</div>
						<div class="meaning-mapper-definition">{{ activity.focus_word.definition }}</div>
					</div>
					<div class="meaning-mapper-branch mm-right">
						<div class="line"></div>
						<div class="meaning-mapper-blank connection"></div>
						<div class="line"></div>
						<div class="meaning-mapper-blank word"></div>
					</div>
				</div>
				<div class="meaning-mapper-row">
					<div class="meaning-mapper-branch mm-secondary">
						<div class="line"></div>
						<div class="meaning-mapper-blank connection"></div>
						<div class="line"></div>
						<div class="meaning-mapper-blank word"></div>
					</div>
					<div class="meaning-mapper-branch spacer mm-bottom"></div>
					<div class="meaning-mapper-branch mm-secondary">
						<div class="line"></div>
						<div class="meaning-mapper-blank connection"></div>
						<div class="line"></div>
						<div class="meaning-mapper-blank word"></div>
					</div>
				</div>
			</div>
			<div class="word-bank-print">
				<h2 class="word-bank-print-title margin-none">Word Bank</h2>
				<ul class="word-bank-print-list">
					<li
						v-for="word in activity.student_word_bank"
						:key="word.word">
						{{ word.word }}
					</li>
				</ul>
			</div>
		</div>
		<modal
			id="meaning-mapper-init"
			class="graphic-organizer-modal"
			:ok="false"
			:closeable="false">
			<template slot="content">
				<validated-form
					ref="rootForm"
					class="meaning-mapper-init-form"
					:on-submit="onInitSubmit">
					<h3
						v-if="!rootNode"
						class="text-centered">
						Begin the Meaning Mapper Activity!
					</h3>
					<div class="meaning-mapper-root-node">
						<div class="input-wrapper text-centered word-part">
							{{ focusWord }}
						</div>
						<validated-textarea
							class="focus-word-definition print-hidden"
							:value="editFocusWordDef"
							@input.native="editFocusWordDef = $event.target.value"
							maxlength="200"
							placeholder="Definition"
							required>
						</validated-textarea>
					</div>
					<div class="text-centered">
						<button
							class="save-notif button"
							type="submit">
							Save
						</button>
						<button
							class="cancel-notif button -outline"
							type="button"
							v-if="rootNode"
							@click="onEndEdit">
							Cancel
						</button>
					</div>
				</validated-form>
			</template>
		</modal>
		<modal
			id="meaning-mapper-add-word"
			class="graphic-organizer-modal"
			:ok="false"
			:closeable="false">
			<template slot="content">
				<validated-form
					ref="editForm"
					class="meaning-mapper-edit-form"
					:on-submit="onCreateNodeSubmit">
					<p>What word does this word make you think of or remind you of? Why? Add it to the word bubble.</p>
					<div class="node-container-form">
						<div
							v-if="rootNode && (rootNode.id === editParentId || (editNode && rootNode.id === editNode.parentId))"
							class="meaning-mapper-root-node text-centered margin-top-medium margin-bottom-medium">
							<div class="word-part">{{ focusWord }}</div>
							<div
								class="focus-word-definition"
								:title="rootNode.text">
								{{ rootText }}
							</div>
						</div>
						<div
							v-if="rootNode && rootNode.id !== editParentId && parentNode"
							class="input-wrapper text-centered word-entry parent-word">
							{{ parentNode.word }}
						</div>
						<div class="line">&nbsp;</div>
						<div class="input-wrapper text-centered connection-entry">
							<validated-textarea
								:value="editLinkText"
								@input.native="editLinkText = $event.target.value"
								:maxlength="200"
								placeholder="Connection"
								required>
							</validated-textarea>
						</div>
						<div class="line">&nbsp;</div>
						<div class="input-wrapper text-centered word-entry">
							<validated-input
								class="word-and-part text-centered"
								type="text"
								:debounce-delay="50"
								required
								v-model.trim="editWord"
								name="editWord"
								maxlength="22"></validated-input>
							<label
								for=""
								placeholder="Word"
								alt="Word"></label>
						</div>
					</div>
					<div class="text-centered">
						<button
							class="save-notif button"
							type="submit">
							Save
						</button>
						<button
							v-if="allowDelete"
							class="delete button -danger"
							type="button"
							@click="onDeleteNode">
							Delete
						</button>
						<button
							class="cancel-notif button -outline"
							type="button"
							@click="onEndEdit">
							Cancel
						</button>
					</div>
				</validated-form>
			</template>
		</modal>
	</div>
</template>
